import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import { updateSettlementAmount } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import ConfirmModal from "../../../components/common/ConfirmModal";

const Modal = ({ onClose, reportData, paidAmount, refreshTableData }) => {
  const token = useSelector((store) => store.userReducer.token);

  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }
    setShowConfirm(true);
  };

  const handleConfirm = async (confirmed) => {
    setShowConfirm(false);
    if (!confirmed) return;

    setLoading(true);
    try {
      await updateSettlementAmount(token, reportData?.id, amount);
      toast.success("Amount paid successfully!");
      refreshTableData();
      onClose();
    } catch (err) {
      toast.error("Failed to update settlement amount");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="amount-modal-overlay">
        <div className="amount-modal-content">
          <button onClick={onClose} className="amount-modal-buttons-close">
            <FaTimes size={25} />
          </button>
          <h2>Pay Settlement Amount</h2>
          <p>Total Settlement Got: ₹{paidAmount}</p>
          <form onSubmit={handleSubmit}>
            <label htmlFor="amountInput">Enter Settlement Amount:</label>
            <input
              id="amountInput"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter Amount"
              required
            />
            <button
              className="amount-modal-buttons"
              type="submit"
              disabled={loading}
            >
              {loading ? "Paying..." : "Submit"}
            </button>
          </form>
        </div>
      </div>

      {showConfirm && <ConfirmModal onResolve={handleConfirm} />}
    </>
  );
};

export default Modal;